import { render, staticRenderFns } from "./v-custom-lp.vue?vue&type=template&id=135a25d4&"
import script from "./v-custom-lp.vue?vue&type=script&lang=js&"
export * from "./v-custom-lp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports